import axios from "./configs/axiosConfig";

export const getClaimsList = async (dealerId) => {
  const url = `claims/${dealerId}`;
  return await axios.get(url);
};

export const rejectClaim = async (id, user, claimIds) => {
  const url = `claims/reject/${id}?uid=${user}&claimids=${claimIds}`;
  return await axios.patch(url);
};

export const updateClaimId = async (id, claimid, user, status, agreementId) => {
  const url = `claims/claimidupdate/${id}?uid=${user}&claimid=${claimid}&status=${status}&agreementid=${agreementId}`;
  return await axios.patch(url);
};

export const updateClaimAgreementId = async (id, isAgreementIdUpdate, agreementId, productCode) => {
  const url = `claims/claimidupdate/${id}?isAgreementIdUpdate=${isAgreementIdUpdate}&agreementid=${agreementId}&productCode=${productCode}`;
  return await axios.patch(url);
};

export const updateClaimFromSt = async (agreementid, claimid) => {
  const url = `/claims/stupdate`;
  return await axios.patch(url, { agreementid, claimid });
};

export const searchClaims = async (key) => {
  const url = `claims/search?key=${key}`;
  return await axios.get(url);
};

export const claimsDownload = async (dealerId,startDate,endDate) => {
  const url = `claims/${dealerId}/download?startdate=${startDate}&&enddate=${endDate}`;
  return await axios.get(url);
};

export const claimsAdTools = async (id,action,userId) => {
  const url = `claims/admtools?id=${id}&&action=${action}&&uid=${userId}`;
  return await axios.put(url);
};

export const claimsDealerAdTools = async (data) => {
  const url = `claims/claimidupdate`;
  return await axios.put(url,data);
};

export const createPotentialClaim = async (data,dealerId) => {
  const url = `claims/${dealerId}/createpotentialclaim`;
  return await axios.post(url, data);
};